export const CLASSIFICATION = {
  completed: 'Completed',
  actionNeeded: 'Action Needed',
  unclassified: 'Unclassified',
  notListed: -1,
  unknown: 'Unknown',
  docCategory: 'documentCategory',
  docType: 'documentType',
};

// Mirrors the NotFound message from bolt-document-association SaveDocumentAssociation
export const INACTIVE_DOCUMENT_ERROR_PATTERN =
  /^Document \d+ is not active and cannot be associated\.?$/;

export const INACTIVE_DOCUMENT_TOAST_MESSAGE =
  'The selected document has been split, merged, or hidden in DocHub. Refresh the page to sync BOLT and DocHub.';

export const DROPDOWN_LABEL = {
  borrowerAssociations: 'Borrower',
  incomeDocumentAssociations: 'Income',
  propertyAssociations: 'Property',
  liabilityDocumentAssociations: 'Liability',
  assetDocumentAssociations: 'Asset',
};

export const DROPDOWN_FIELD = {
  associationDetails: 'associationDetails',
};

export const ClassifyRuleIds = {
  DocumentAction: 1,
  Completed: 2,
  QuickMatch: 3,
  DocumentView: 4,
  Error: -1,
} as const;
